import Axios from '@/utils/axios';
import { IssueListRequest, IssueListResponse, Issue } from '@/types/common';
import { getBackendErrorMessage } from '@/utils/errorHandler';

export interface CreateIssueRequest {
  issueType: string;
  handoverID: string;
  driverID?: number;
  driverCode?: string;
  driverName?: string;
  clientID?: number;
  clientName?: string;
  incidentDate: string;
  severity: string;
  estimatedCost: number;
  costResponsibility: string;
  imageURL: string;
  notes: string;
  createdBy: string;
  oemID?: string;
}

export const getListIssues = async (
  params?: IssueListRequest
): Promise<IssueListResponse> => {
  try {
    const response = await Axios.get('/v1/issues', { params });
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export const getIssueById = async (id: string): Promise<Issue> => {
  try {
    const response = await Axios.get(`/v1/issues/${id}`);
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export const createIssue = async (data: CreateIssueRequest): Promise<any> => {
  try {
    const response = await Axios.post('/v1/issues', data);
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export interface UpdateIssueRequest {
    costResponsibility?: string;
    oemID?: string;
    driverID?: number;
    driverCode?: string;
    driverName?: string;
    clientID?: number;
    clientName?: string;
    severity?: string;
    estimatedCost?: number;
    imageURL?: string;
    notes?: string;
    incidentDate?: string;
    updatedBy: string;
}

export const updateIssue = async (
  id: string,
  data: UpdateIssueRequest
): Promise<any> => {
  try {
    const response = await Axios.patch(`/v1/issues/${id}`, data);
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export interface SpawnMaintenanceRequest {
  categories: string[];
  issueDescription: string;
  estimatedCost: number;
  costResponsibility: string;
  oemServiceCenter: string;
  maintenanceDate: string;
  expectedCompletionDate: string;
  createdBy: string;
  vehicleImageURL?: string;
  notes?: string;
  severity?: string;
}

export const spawnMaintenanceFromIssue = async (
  id: string,
  data: SpawnMaintenanceRequest
): Promise<any> => {
  try {
    const response = await Axios.patch(
      `/v1/issues/${id}/spawn-maintenance`,
      data
    );
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export interface MarkIssueRequest {
  updatedBy: string;
}

export const markIssueAsClose = async (
  id: string,
  data: MarkIssueRequest
): Promise<any> => {
  try {
    const response = await Axios.patch(`/v1/issues/${id}/mark-as-close`, data);
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};
